import { Redirect } from "react-router-dom";

import { HOME } from "../../constants/router";

const GuardedRoute = ({ isShow, to, children, userRoleGuard }) => {
  if (!isShow) return <Redirect to={to} />;
  if (userRoleGuard === false) return <Redirect to={HOME.root} />;
  return children;
};

export default GuardedRoute;
